import { configureStore } from "@reduxjs/toolkit"
import sidebarSlice from "features/sidebar/sidebarSlice"
import commonSlice from "features/common/commonSlice"
import baseXlsFormSlice from "pages/BaseXlsForm/baseXlsFormSlice"
import { geoDataApi } from "services/geoData/geoDataApi"
import { coreApi } from "services/core/coreApi"
import { api } from "services/api"
import { aimsBackendApi } from "services/aimsBackend"
import { marketpricesApi } from "services/marketprices/marketpricesApi"
import { householdApi } from "services/household/householdApi"
import { mfiApi } from "services/mfi/mfiApi"
import { rpmeApi } from "services/rpme/rpmeApi"

export const store = configureStore({
  reducer: {
    sidebar: sidebarSlice,
    baseXlsForm: baseXlsFormSlice,
    common: commonSlice,
    [api.reducerPath]: api.reducer,
    [aimsBackendApi.reducerPath]: aimsBackendApi.reducer,
    [marketpricesApi.reducerPath]: marketpricesApi.reducer,
    [geoDataApi.reducerPath]: geoDataApi.reducer,
    [coreApi.reducerPath]: coreApi.reducer,
    [householdApi.reducerPath]: householdApi.reducer,
    [mfiApi.reducerPath]: mfiApi.reducer,
    [rpmeApi.reducerPath]: rpmeApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat([
      api.middleware,
      aimsBackendApi.middleware,
      coreApi.middleware,
      geoDataApi.middleware,
      marketpricesApi.middleware,
      householdApi.middleware,
      mfiApi.middleware,
      rpmeApi.middleware,
    ]),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
